<template>
  <div class="section-box">
    <div class="box-item">
      <div class="left-part">
        <div class="section-box-item" v-html="itemContent"></div>
      </div>
      <div class="right-part">
        <div class="section-item-action">
          <a class="btn btn-warning btn-select" @click="handleBtnAgree($event)">{{ $t("customer.agree.yes") }}</a>
          <a class="btn btn-default" @click="handleBtnDefault($event)">{{ $t("customer.agree.no") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "SectionBoxYesNo",
  props: {
    itemContent: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleBtnAgree(event) {
      $(event.target).parents('.right-part').toggleClass('selected');
      $(event.target).toggleClass('selected');
      $(event.target).parents(".box-item").toggleClass('answered');
      this.$emit('clickBtnYes');
    },

    handleBtnDefault(event) {
      $(event.target).parents('.right-part').removeClass('selected');
      $(event.target).parents(".box-item").removeClass('answered');
      $(event.target).parents('.right-part').find('.btn-select').removeClass('selected');
      this.$emit('clickBtnNo');
    }
  }
}
</script>

<style scoped>
.btn-warning {
  margin-right: 2px;
  color: white !important;
}

.btn-default {
  margin-left: 2px;
}
</style>